import React, { useMemo, useEffect, useState } from 'react';
import BeneficiarioItem from './BeneficiarioItem';

const Listado = ({
  camposKey = 'camposBeneficiarios',
  data = [],
  showDelete = true,
  isTitular = false,
  index = 0
}) => {


  const [datos, setDatos] = useState([])
  useEffect(() => {

    let array = data.map((miObjeto) => {
      let objectoGrupo = {};
      Object.keys(miObjeto).forEach((entr, index) => {
        let auxiliar = {};
        auxiliar["esUnTitulo" + (index + 1)] = entr;
        if (!Array.isArray(miObjeto[entr]) && Object.keys(miObjeto[entr]).length > 0) {
          objectoGrupo = { ...objectoGrupo, ...auxiliar, ...miObjeto[entr] };
        }
      })
      return objectoGrupo;
    })
    setDatos(array)
  }, [data])


  if (datos.length === 1 && Object.keys(datos[0]).length === 0) return <></>
  

  return <div className="col-11 col-md-10 col-lg-7 mb-1">
    {datos?.map((beneficiario, i) => (<BeneficiarioItem
      beneficiario={beneficiario}
      index={index}
      key={i}
      camposKey={camposKey}
      showDelete={showDelete}
      isTitular={isTitular}
    />)
    )}
  </div>;
};

export default Listado;